import { useState, Dispatch, SetStateAction } from 'react'
import { fetchGuestRoomForReservation } from '@/apis/aipass'
import { GuestRoomAssignResponseType } from '@/models/guest-room/guest-room-assign'

export type EditRoomType = Partial<GuestRoomAssignResponseType['rooms'][0]>

type UseEditGuestRoomsType = [
  EditRoomType[],
  Dispatch<SetStateAction<EditRoomType[]>>,
  (params: { reservationId: string }) => Promise<GuestRoomAssignResponseType['rooms']>,
]

// Room list to edit
export function useEditGuestRooms(): UseEditGuestRoomsType {
  const [editGuestRooms, setEditGuestRooms] = useState<EditRoomType[]>([])

  const handleFetchGuestRooms = async ({ reservationId }: { reservationId: string }) => {
    return await fetchGuestRoomForReservation(reservationId).then(guestRooms => {
      if (!guestRooms) {
        return []
      }

      setEditGuestRooms(guestRooms)
      return guestRooms
    })
  }

  return [editGuestRooms, setEditGuestRooms, handleFetchGuestRooms]
}
